import { render, staticRenderFns } from "./ExtendedProfiling.vue?vue&type=template&id=86009804&"
import script from "./ExtendedProfiling.vue?vue&type=script&lang=js&"
export * from "./ExtendedProfiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports